var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2792AA48-1C83-468E-A33E-086AC58D140E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-364.000000, -444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee",
    transform: "translate(364.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25,4.37109375 L5.25,2.62109363 C5.25,2.21109363 5.59,1.87109375 6,1.87109375 C6.41,1.87109375 6.75,2.21109363 6.75,2.62109363 L6.75,4.37109375 C6.75,4.79109374 6.41,5.12109375 6,5.12109375 C5.59,5.12109375 5.25,4.78109375 5.25,4.37109375 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25,4.37109375 L9.25,2.62109363 C9.25,2.21109363 9.59,1.87109375 10,1.87109375 C10.41,1.87109375 10.75,2.21109363 10.75,2.62109363 L10.75,4.37109375 C10.75,4.79109374 10.41,5.12109375 10,5.12109375 C9.59,5.12109375 9.25,4.78109375 9.25,4.37109375 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25,4.37109375 L13.25,2.62109363 C13.25,2.21109363 13.59,1.87109375 14,1.87109375 C14.41,1.87109375 14.75,2.21109363 14.75,2.62109363 L14.75,4.37109375 C14.75,4.79109374 14.41,5.12109375 14,5.12109375 C13.59,5.12109375 13.25,4.78109375 13.25,4.37109375 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6599998,8.29171848 C16.9199998,7.08171844 15.5999999,6.26171875 14.0799999,6.26171875 L6.71000004,6.26171875 C4.3900001,6.26171875 2.5,8.15171885 2.5,10.4717188 L2.5,11.0017185 L18.2900009,11.0017185 L18.2900009,10.4717188 C18.2900009,10.2817188 18.2599995,10.0917184 18.2299995,9.91171837 C19.6799996,10.3417184 20.75,11.6617185 20.75,13.2517185 C20.75,14.8217186 19.7100009,16.1317182 18.2900009,16.5717182 L18.2900009,12.0017185 L2.5,12.0017185 L2.5,17.7917194 C2.5,20.1117194 4.3900001,22.0017185 6.71000004,22.0017185 L14.0799999,22.0017185 C16.28,22.0017185 18.07,20.301718 18.25,18.1417179 C20.53,17.6817179 22.25,15.6617186 22.25,13.2517185 C22.25,10.6317186 20.2199998,8.51171848 17.6599998,8.29171848 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCoffee);
export default __webpack_public_path__ + "static/media/vuesax-bold-coffee.ba36cbfd735a370b5a874461bbe47aa5.svg";
export { ForwardRef as ReactComponent };